import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";

export function SettingsFormSkeleton() {
  return (
    <div className="space-y-6">
      {/* Radio group with correct spacing */}
      <div className="space-y-4">
        <div className="space-y-2">
          {/* Radio option 1 - No verifier with warning */}
          <div className="flex items-start space-x-4 rounded-lg border border-border bg-card p-5">
            <div className="mt-1">
              <Skeleton className="h-4 w-4 rounded-full" />
            </div>
            <div className="flex flex-1 items-start space-x-4">
              <div className="flex-1 space-y-3">
                <div className="flex items-center justify-between">
                  <Skeleton className="h-4 w-32" /> {/* Title */}
                  <Skeleton className="h-5 w-16 rounded-md" /> {/* Badge */}
                </div>
                <Skeleton className="h-4 w-full" /> {/* Description */}
                <Skeleton className="h-4 w-3/4" /> {/* Description line 2 */}
                {/* NoVerifierWarning skeleton */}
                <div className="mt-4 flex items-start space-x-3 rounded-md border border-warning/20 bg-warning/10 p-4">
                  <Skeleton className="mt-0.5 h-4 w-4 shrink-0" />{" "}
                  {/* AlertTriangle icon */}
                  <div className="space-y-2">
                    <Skeleton className="h-4 w-28" /> {/* "Security Warning" */}
                    <Skeleton className="h-3 w-full" />{" "}
                    {/* Warning text line 1 */}
                    <Skeleton className="h-3 w-4/5" />{" "}
                    {/* Warning text line 2 */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Radio option 2 - Arcade session */}
          <div className="flex items-start space-x-4 rounded-lg border border-border bg-card p-5">
            <div className="mt-1">
              <Skeleton className="h-4 w-4 rounded-full" />
            </div>
            <div className="flex flex-1 items-start space-x-4">
              <div className="flex-1 space-y-3">
                <div className="flex items-center justify-between">
                  <Skeleton className="h-4 w-40" /> {/* Title */}
                  <Skeleton className="h-5 w-20 rounded-md" /> {/* Badge */}
                </div>
                <Skeleton className="h-4 w-full" /> {/* Description */}
                <Skeleton className="h-4 w-2/3" /> {/* Description line 2 */}
              </div>
            </div>
          </div>

          {/* Radio option 3 - Custom verifier */}
          <div className="flex items-start space-x-4 rounded-lg border border-border bg-card p-5">
            <div className="mt-1">
              <Skeleton className="h-4 w-4 rounded-full" />
            </div>
            <div className="flex flex-1 items-start space-x-4">
              <div className="flex-1 space-y-3">
                <div className="flex items-center justify-between">
                  <Skeleton className="h-4 w-36" /> {/* Title */}
                  <Skeleton className="h-5 w-18 rounded-md" /> {/* Badge */}
                </div>
                <Skeleton className="h-4 w-full" /> {/* Description */}
                <Skeleton className="h-4 w-5/6" /> {/* Description line 2 */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom verifier URL section */}
      <div className="px-4">
        <div className="h-px bg-border" /> {/* Separator */}
        <div className="mt-5 space-y-4">
          <div className="flex items-center gap-3">
            <Skeleton className="h-5 w-5" /> {/* Globe icon */}
            <Skeleton className="h-5 w-40" /> {/* "Custom verifier URL" */}
            <Skeleton className="h-4 w-2" /> {/* Required asterisk */}
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" /> {/* Description line 1 */}
            <Skeleton className="h-4 w-3/4" /> {/* Description line 2 */}
          </div>
          <Skeleton className="h-10 max-w-lg" /> {/* Input field */}
        </div>
      </div>

      {/* Bottom separator */}
      <div className="h-px bg-border" />

      {/* Submit section */}
      <div className="flex items-center justify-between pt-2">
        <Skeleton className="h-4 w-64" /> {/* Help text */}
        <Skeleton className="h-10 w-32" /> {/* Submit button */}
      </div>
    </div>
  );
}
